import { useShowLocation } from '@givebacks/api/offers';
import { Group, Stack, Text, Title } from 'ui';

import { MerchantType } from '../MerchantDetailModalsProvider';

const HoursOfOperation = ({ locationId, type }: { locationId?: string; type?: MerchantType }) => {
  const { data: locationData } = useShowLocation({
    locationId: locationId,
  });

  if (type === 'online') return null;
  if (locationData?.hours.length === 0) return null;
  return (
    <Stack gap="sm">
      <Title order={4}>Hours of Operation</Title>
      {locationData?.hours.map((hour) => (
        <Group key={hour.day_integer} justify="space-between">
          <Text type="sub">{hour.day}</Text>
          <Text type="sub">{`${hour.opens_at} - ${hour.closes_at}`}</Text>
        </Group>
      ))}
    </Stack>
  );
};

export { HoursOfOperation };
